/* eslint-disable react/prop-types */
import { useUser } from "../../context";

import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";
import MotionDiv from "../MotionDiv";
import { Trans } from "react-i18next";
import KioskAvatar from "../KioskAvatar";
const motionProps = {
  initial: { x: "-100%", opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: { opacity: 0 },
  transition: {
    type: "tween",
    duration: 0.1,
  },
};

const UserBar = ({ user }) => {
  const userData = useUser();
  // TODO: This fixes #3978, however, the response from the api should return a value we can trust and this should be removed
  const userGender = userData?.user?.Gender === "Female" ? "female" : "male";
  return (
    <Box layerStyle={"kioskSidebar"}>
      <KioskAvatar name={`${user?.FirstName} ${user?.LastName}`} />
      <Box
        w={"full"}
        flex={1}
        maxW={"full"}
        overflow={"hidden"}
        as={motion.div}
        key={1}
        {...motionProps}
        transition={{ delay: 0 }}
      >
        <motion.div key={2} {...motionProps} transition={{ delay: 0.2 }}>
          <Text
            textAlign="left"
            fontSize="2xl"
            mt="7"
            as={motion.div}
            key={2}
            {...motionProps}
            transition={{ delay: 1 }}
          >
            <Trans i18nKey={"welcome"} context={userGender}>
              Welcome
            </Trans>
          </Text>
        </motion.div>
        <MotionDiv
          key={3}
          {...motionProps}
          transition={{ delay: 0.4 }}
          w={"full"}
        >
          <Text
            mt={"0 !important"}
            lineHeight={"3rem"}
            fontWeight="bold"
            color="brand.secondary.500"
            mode="single"
            fontSize="4xl"
            noOfLines={2}
            overflow={"hidden"}
          >
            {user?.FirstName} {user?.LastName?.charAt(0)}
          </Text>
        </MotionDiv>
      </Box>
      {/*<Box>*/}
      {/*  <MotionDiv*/}
      {/*    key={4}*/}
      {/*    {...motionProps}*/}
      {/*    transition={{ delay: 0.4 }}*/}
      {/*    w={"full"}*/}
      {/*  >*/}
      {/*    <Box>*/}
      {/*      <Text textAlign="left" fontSize="2xl" mt="7">*/}
      {/*        Appointments:*/}
      {/*      </Text>*/}
      {/*      <Text*/}
      {/*        mt={"0 !important"}*/}
      {/*        display={"block"}*/}
      {/*        fontWeight="normal"*/}
      {/*        w={"full"}*/}
      {/*        color="brand.secondary.500"*/}
      {/*        mode="single"*/}
      {/*        fontSize="xl"*/}
      {/*      >*/}
      {/*        {"Tanning @ 3:30pm"}*/}
      {/*      </Text>*/}
      {/*      <Text*/}
      {/*        mt={"0 !important"}*/}
      {/*        display={"block"}*/}
      {/*        fontWeight="normal"*/}
      {/*        w={"full"}*/}
      {/*        color="brand.secondary.500"*/}
      {/*        mode="single"*/}
      {/*        fontSize="xl"*/}
      {/*      >*/}
      {/*        {"Massage @ 4:00pm"}*/}
      {/*      </Text>*/}
      {/*    </Box>*/}
      {/*  </MotionDiv>*/}
      {/*</Box>*/}
    </Box>
  );
};
export default UserBar;
